module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phantom-container"
  }, [_c('notifications', {
    attrs: {
      "group": "default"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('loader')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b0f5c4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 636
// module chunks = 1